import script from "./LangSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./LangSelector.vue?vue&type=script&setup=true&lang=js"

import "./LangSelector.vue?vue&type=style&index=0&id=624f2de0&lang=less"

const __exports__ = script;

export default __exports__